import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-progress-circle',
    templateUrl: './progress-circle.component.html',
    styleUrls: ['./progress-circle.component.scss']
})
export class ProgressCircleComponent implements OnInit {

    @Input() completed: number = 0;
    @Input() total: number = 1;
    constructor() { }

    ngOnInit(): void {
    }

  get percent(): number {
  return Math.round((this.completed / this.total) * 100);
}

    get dashOffset(): number {
        const circumference = 100;
        return circumference - (this.percent / 100) * circumference;
    }

}
